import Icon from "../Icon";
import PropTypes from "prop-types";
import React from "react";
import classes from "./Button.module.css";
import classnames from "classnames";

export const ButtonIcon = ({ className, ...props }) =>
  <Icon className={classnames(classes.btnIcon, className)} {...props} />;

ButtonIcon.propTypes = {
  className: PropTypes.string
};

export default ButtonIcon;



// WEBPACK FOOTER //
// ./src/app/components/UI/Button/ButtonIcon.js